export const exportableData = [
  "all",
  "user_name",
  "user_mobile",
  "user_email",
  "gym_name",
  "biomax_first_step",
  "is_biomax_registered",
  "last_checkin",
  "last_workout_date",
  "assigned_to_name",
  "assigned_to_mobile",
  "assigned_to_email",
  "isfitness_profile_completed",
  "handover_status",
  "trial_status",
  "rating_status",
  "assigned_date",
  "pt_initiate_date",
  "assigned_by_name",
  "current_plan_name",
  "sub_added_by_name",
  "current_plan_status",
  "profession",
  "is_pt_prspct",
  "trnr_intro_status",
  "last_checkin_time_filter",
  "last_checkin_days_ago",
  "assigned_date_days_ago",
  "pt_initiate_date_days_ago",
  "prspct_status",
  "prspct_duration",

  "regular_start_date",
  "regular_expire_date",
  "pt_schedule_start_date",
  "pt_schedule_end_date",
  "expctd_closure_start_date",
  "expctd_closure_end_date",
  "expctd_closure_date",
  "pt_prspct_reason",

  "assesment_doc_status",
  "profile_doc_status",
  "ftns_cnsltnt_doc1_status",
  "rating_id",

  "three_day_assigned",
  "threeday_start_date",
  "threeday_expire_date",
  "threeday_slot_start",
  "threeday_slot_end",
  "threeday_assign_to",
  "threeday_assign_from",
  "pt_initiated_date_from",
  "pt_initiated_date_to",
  "bca_report_status",
  "payment_location",
];

export const leadExportableData = [
  "all",
  "name",
  "mobile",
  "email",
  "lead_type",
  "cutomer_intent",
  "current_followup_status",
  "next_followup_date",
  "expected_closure_date",
  "lead_value",
  "plan_type",
  "conversion_date",
  "lead_status",
  "gym_name",
  "source_name",
  "added_by_name",
  "assigned_to_name",
  "date_added",
];

export const dashboardReportsDetailsV2 = [
  "all",
  "name",
  "mobile",
  "email",
  "gym_name",
  "type",
  "subs_reference_id",
  "plan_name",
  "addon_name",
  "price",
  "date_added",
  "start_date",
  "expire_date",
  "subscription_status",
  "expired_days_ago",
  "subscription_expiry_days",
  "last_checkin_date",
  "checkin_time",
  "last_checkin_days_ago",
  "trx_id",
  "is_partial",
];

export const rawLeadExportableData = [
  "all",
  "name",
  "mobile",
  "email",
  "is_assigned",
  "added_to_lead",
  "keyword_name",
  "source_name",
  "utm_source",
  "utm_medium",
  "utm_content",
  "utm_term",
  "utm_campaign",
  "ga_medium",
  "date",
  "preferred_slot",
  "lead_added_count",
  "assigned_by_name",
  "gym_name",
  "assigned_to_name",
  "date_added",
  "assigned_date",
  "rawlead_to_assign_day",
  "assign_to_followup",
  "first_followup",
  "conversion_date",
  "city",
];

export const exportableODMTableData = [
  "all",
  "user_name",
  "user_mobile",
  "user_email",
  "gym_name",
  "converted_date",
  "start_date",
  "expire_date",
  "current_plan_name",
  "current_plan_status",
  "converted_plan_name",
  "converted_plan_price",
  "is_converted",
  "subscription_expiry_days",
  "utm_campaign",
  "utm_source",
  "utm_medium",
  "utm_content",
  "utm_term",
  "ga_source",
  "ga_medium",
  "ga_campaignid",
  "ga_adgroupid",
  "ga_device",
  "ga_keyword",
  "ga_location",
  "gclid",
  "city",
  "status",
  "date_added",
  "remarks",
  "source_name",
];

export const getSelectedValue = (array, key, rowData, name) =>
  name === "edit" && rowData?.[key]
    ? array.find((item) => item.value === rowData[key]) || ""
    : "";

export const getTestLabel = (array, value) => {
  const foundItem = array.find((item) => item.value === value);
  return foundItem ? foundItem.label : "-";
  // return foundItem ? foundItem.label : "Not Available";
};

export const exportableUnmappedKeywordsData = [
  "all",
  "assigned_to",
  "assigned_to_name",
  "assigned_to_mobile",
  "assigned_to_email",
  "added_on_lead",
  "lead_id",
  "lead_status",
  "source_name",
  "added_to_lead",
  "gym_id",
  "gym_name",
  "current_followup_status",
  "added_on_first_follow_up",
  "add_to_lms_time_dif",
  "converted_date",
  "start_date",
  "expire_date",
  "converted_plan_name",
  "converted_plan_price",
  "is_converted",
  "id",
  "uid",
  "name",
  "mobile",
  "message",
  "status",
  "date_added_val",
  "date_added",
  "last_updated",
  "sheet_id",
  "tab_name",
  "sheet_name",
];

export const exportableWatiLeadsData = [
  "all",
  "assigned_to",
  "assigned_to_name",
  "assigned_to_mobile",
  "assigned_to_email",
  "added_on_lead",
  "lead_id",
  "lead_status",
  "source_name",
  "added_to_lead",
  "gym_id",
  "gym_name",
  "current_followup_status",
  "added_on_first_follow_up",
  "add_to_lms_time_dif",
  "converted_date",
  "start_date",
  "expire_date",
  "converted_plan_name",
  "converted_plan_price",
  "is_converted",
  "id",
  "uid",
  "name",
  "email",
  "mobile",
  "keyword_name",
  "message",
  "status",
  "date_added_val",
  "date_added",
  "last_updated",
  "sheet_id",
  "tab_name",
  "sheet_name",
];
